import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { APP_URL } from "../request/api";

import { request } from "../request/request";

const initialState = {
    filtersList: {},
    loaded: false,
    loadingStatus: "idle",
    error: null
}

export const fetchFilters = createAsyncThunk(
    'filterList/fetchFilters',
    async ({token}, { rejectWithValue }) => {
        try {
            const customHeaders = {
                Authorization: `Bearer ${token}`
            }

            return await request(
                `${APP_URL}/auxiliary/report-filters`,
                'GET',
                null,
                customHeaders
            );
        } catch (error) {
            return rejectWithValue(error.status)
        }
    }
);

const filtersListSlice = createSlice({
    name: 'filterList',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchFilters.pending, (state) => {
                state.filtersList = {};
                state.loadingStatus = "loading";
                state.error = null;
            })
            .addCase(fetchFilters.fulfilled, (state, action) => {
                state.filtersList = action.payload;
                state.loadingStatus = "idle";
                state.loaded = true;
                state.error = null
            })
            .addCase(fetchFilters.rejected, (state, action) => {
                state.filtersList = {};
                state.loadingStatus = "error";
                state.error = action.payload;
            })
    }
})

export default filtersListSlice.reducer;